import { useCallback, useEffect, useState } from 'react';
import { loadDirectLoginsAsync } from '../../../../data-layer/direct/actions';
import {
    selectDirectLogins,
    selectDirectLoginsLoading,
} from '../../../../data-layer/direct/selectors';
import { DirectCampaignUI } from '../../../../data-layer/direct/types';
import { useDispatch } from '../../../../data-layer/useDispatch';
import { useSelector } from '../../../../data-layer/useSelector';
import { useCurrentUser } from '../../../users/useCurrentUser';

export const useDirectLogins = (company?: DirectCampaignUI, isEditMode?: boolean) => {
    const currentUser = useCurrentUser();
    const dispatch = useDispatch();
    const logins = useSelector(selectDirectLogins);
    const isLoagingLogins = useSelector(selectDirectLoginsLoading);
    const [selectedLogin, setSelectedLogin] = useState<string | undefined>(
        isEditMode ? company?.login : currentUser?.login,
    );
    const onChangeLogin = useCallback((value: string) => {
        setSelectedLogin(value);
    }, []);

    useEffect(() => {
        if (isEditMode) {
            return;
        }

        dispatch(loadDirectLoginsAsync());
    }, [isEditMode, dispatch]);

    return { selectedLogin, isLoagingLogins, logins, onChangeLogin };
};
